import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cta: 'Contact us',
    description:
      'The information you provided about your company needs to be verified.',
    title: 'Please contact us to proceed to the next step',
  },
  fr: {
    cta: 'Nous contacter',
    description:
      'Les informations renseignées concernant votre entreprise ont besoin d’être vérifiées.',
    title: 'Veuillez nous contacter pour passer à l’étape suivante',
  },
} as const);
